import { Button } from '@mui/material'
import React from 'react'
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import Styles from '../Config/Styles';

const ButtonBox = ({ text, onClick, type, disabled=false, color ,textcolor}) => {
    
    return (
        <Button
            variant="contained"
            fullWidth
            startIcon={type == "phone" && <WhatsAppIcon />}
            sx={Styles.btnstyle(color,textcolor).btn}
            onClick={onClick}
            disabled={disabled}
        >
            {text}
        </Button>
    )
}

export default ButtonBox